<template>
  <div class="inputDiv"
       :id="'inputDiv'+index+subIndex"
       contenteditable="true"
       @input="changeAmount"
       @keydown="onkeydown"
  >{{ removeHTMLTags(amount) }}
  </div>
</template>

<script>
export default {
  name: 'inputDiv',
  props: ['amount', 'index', 'subIndex'],
  methods: {
    removeHTMLTags(str) {
      let val = str
      val = str.replace(/<[^>]*>/g, '').replace(/[^0-9.]/g, '')
      return val
    },
    textareaRange(input) {
      let el = input.childNodes
      let rang = document.createRange()
      if (el.length >= 1) {
        rang.selectNodeContents(el[el.length - 1])
      }
      rang.collapse(false)
      let sel = document.getSelection()
      if (sel.anchorOffset != 0) return
      sel.removeAllRanges()
      sel.addRange(rang)
    },
    onkeydown(event) {
      if (!((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105) || (event.keyCode == 8) || (event.keyCode == 110) || (event.keyCode == 190) || (event.keyCode == 189))) {
        console.log(event.keyCode)
        //阻止默认的行为发生
        if (event.preventDefault) {
          event.preventDefault()
        } else {
          event.returnValue = false
        }
      }
    },
    changeAmount() {
      let option = {
        amount: this.removeHTMLTags(this.$el.innerHTML),
        index: this.index,
        subIndex: this.subIndex,
        divID: 'inputDiv' + this.index + this.subIndex
      }
      this.$emit('inputAmount', option)
      // document.getElementById('inputDiv' + this.index + this.subIndex).focus()
      // this.textareaRange(document.getElementById('inputDiv' + this.index + this.subIndex))
    }
  }
}
</script>
